import { ElementType, forwardRef } from "react";
import {
  Radio,
  RadioGroup as RadioGroupPrimitive,
  RadioGroupProps as RadioGroupPrimitiveProps,
} from "@headlessui/react";

export interface RadioGroupOption {
  value: string;
  label: string;
}

interface RadioGroupProps
  extends Partial<
    RadioGroupPrimitiveProps<ElementType<HTMLDivElement>, string>
  > {
  options: RadioGroupOption[];
}

export const RadioGroup = forwardRef<HTMLDivElement, RadioGroupProps>(
  ({ options, ...props }, ref) => {
    return (
      <RadioGroupPrimitive as="div" ref={ref} {...props}>
        {options.map((option) => (
          <Radio key={option.value} value={option.value}>
            {({ checked, disabled }) => (
              <div className="flex cursor-pointer items-center gap-1">
                <input
                  readOnly
                  checked={checked}
                  disabled={disabled}
                  type="radio"
                  className="size-4 border-2 border-neutral-700 bg-neutral-25 text-primary-500 focus:ring-1 focus:ring-primary-500 disabled:text-gray-300"
                />
                <p>{option.label}</p>
              </div>
            )}
          </Radio>
        ))}
      </RadioGroupPrimitive>
    );
  },
);

RadioGroup.displayName = "RadioGroup";
